import { memoize } from 'lodash';
import Cookies from 'universal-cookie';

export const isAutomationEnvironment = memoize(() => {
  const cookies = new Cookies();
  return Boolean(cookies.get('is_automation'));
});
